import React from 'react';
import { connect } from 'react-redux';
import TooltipElement from '../components/tooltipElement';
import TooltipButtonGroup from '../components/tooltipButtonGroup';
import TrialRejectedDevicesTable from '../components/trialRejectedDevicesTable';
import OverlayLoader from '../components/overlayLoader';
import TableSelectionManager from '../components/tableSelectionManager';
import * as trialRejectedDevicesActions from '../store/trialRejectedDevicesSlice';
import * as trialSettingsActions from '../store/trialSettingsSlice';
import { trialSettingsSelectors } from '../store/trialSettingsSlice';
import { trialRejectedDevicesSelectors } from '../store/trialRejectedDevicesSlice';
import TrialRejectedDevicesEditDialog from './trialRejectedDeviceEditDIalog';
import TrialRejectedDeviceHistoryDialog from './trialRejectedDeviceHistoryDialog';
import ModalMessage from './modalMessage';
import setTitleToFilters from '../common/filtersTitles';

import './common.css';
import { userConfigsSelectors } from '../store/userConfigs';
import TrialGeneralSettingsEditDialog from './trialGeneralSettingsEditDialog';
import TrialSettingsHistoryDialog from './trialSettingsHistoryDialog';

const thatObjectName = 'trialRejectedDevices';

class TrialRejectedDevicesContainer extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			showTrialGeneralSettingsEditDialog: false,
			showTrialSettingsHistoryDialog: false,

			showTrialRejectedDevicesEditDialog: false,

			trialRejectedDevicesEditDialogMode: TrialRejectedDevicesEditDialog.Mode.Create,
			showHistoryDialog: false,
		};
	}

	componentDidMount() {
		setTitleToFilters();
		this.props.fetchAllTrialRejectedDevices();
		this.props.fetchTrialSettings();
	}

	render() {
		return (
			<OverlayLoader active={this.isLoading()} text={this.getLoaderMessage()}>
				<div>
					<h1>Trial settings</h1>

					{this.renderGeneralSettings()}
					{this.renderTrialGeneralSettingsEditDialog()}
					{this.renderTrialSettingsHistoryDialog()}

					<h3 className='mb-4'>Rejected devices</h3>
					{this.renderButtons()}
					{this.renderContent()}
					{this.renderModalMessage()}
					{this.renderTrialRejectedDevicesEditDialog()}
					{this.renderHistoryDialog()}
				</div>
			</OverlayLoader>
		);
	}

	renderGeneralSettings = () => {
		return (
			<div>
				<div className='d-flex align-items-center'>
					<h3 className='mb-4'>General settings</h3>
					<div className='ml-3 mt-1'>
						<TooltipButtonGroup>
							<TooltipElement
								type='button'
								text='Edit general settings'
								icon='edit'
								onClick={() => {
									this.showTrialGeneralSettingsEditDialog();
								}}
								disabled={false}
								displayOnlyForWriter
							/>
							<TooltipElement
								type='button'
								text='Show history'
								icon='list-alt'
								onClick={() => {
									this.showTrialGeneralSettingsHistoryDialog();
								}}
								disabled={false}
								displayOnlyForWriter
							/>
						</TooltipButtonGroup>
					</div>
				</div>
				<div className='ml-4'>
					<div>
						<b>Minimum allowed viewer version</b> - {this.props.selectedMinAllowedViewerVersion}
					</div>
				</div>
				<div className='ml-4 d-flex'>
						<b>Once a year</b><span className="ml-1">- {this.props.selectedOnceAYear ? 'ENABLED' : 'DISABLED'}</span>
				</div>
			</div>
		);
	};

	renderButtons = () => (
		<TooltipButtonGroup>
			<TooltipElement
				type='button'
				text='Refresh'
				icon='refresh'
				onClick={this.props.fetchAllTrialRejectedDevices}
			/>
			<TooltipElement
				type='button'
				text='Create trial rejected device'
				icon='plus'
				onClick={this.createNewTrialRejectedDevice}
				displayOnlyForWriter
			/>
			<TooltipElement
				type='button'
				text='Edit trial rejected device'
				icon='edit'
				onClick={this.updateTrialRejectedDevice}
				disabled={this.isEditButtonDisabled()}
				displayOnlyForWriter
			/>
			<TooltipElement
				type='button'
				text='Show trial rejected device history'
				icon='list-alt'
				onClick={this.showTrialRejectedDeviceHistory}
				disabled={this.isHistoryButtonDisabled()}
			/>
		</TooltipButtonGroup>
	);

	renderContent = () => {
		if (this.props.trialRejectedDevicesFetchingError)
			return this.renderError(this.props.trialRejectedDevicesFetchingError.toString());
		return (
			<TableSelectionManager items={this.props.trialRejectedDevices} objectName={thatObjectName}>
				<TrialRejectedDevicesTable trialRejectedDevices={this.props.trialRejectedDevices} />
			</TableSelectionManager>
		);
	};

	renderError = (message) => <p className='text-danger'>Error: {message}</p>;

	renderModalMessage = () => <ModalMessage />;

	isLoading = () => this.props.isTrialRejectedDevicesFetching;

	getLoaderMessage = () => {
		if (this.props.isTrialRejectedDevicesFetching) return 'Trial settings are loading...';
	};

	renderTrialGeneralSettingsEditDialog = () => (
		<TrialGeneralSettingsEditDialog
			mode={this.state.trialRejectedDevicesEditDialogMode}
			show={this.state.showTrialGeneralSettingsEditDialog}
			onClose={this.closeTrialGeneralSettingsEditDialog}
		/>
	);

	renderTrialSettingsHistoryDialog = () => {
		return (
			<TrialSettingsHistoryDialog
				id={1}
				show={this.state.showTrialSettingsHistoryDialog}
				onClose={this.closeTrialGeneralSettingsHistoryDialog}
			/>
		);
	};

	showTrialGeneralSettingsHistoryDialog = () => {
		this.setState({
			showTrialSettingsHistoryDialog: true,
		});
	};

	closeTrialGeneralSettingsHistoryDialog = () => {
		this.setState({
			showTrialSettingsHistoryDialog: false,
		});
	};

	showTrialGeneralSettingsEditDialog = () => {
		this.setState({
			showTrialGeneralSettingsEditDialog: true,
		});
	};

	closeTrialGeneralSettingsEditDialog = () => {
		this.setState({
			showTrialGeneralSettingsEditDialog: false,
		});
	};

	renderTrialRejectedDevicesEditDialog = () => (
		<TrialRejectedDevicesEditDialog
			id={this.getSelectedTrialRejectedDeviceFieldValue('id')}
			isOn={this.getSelectedTrialRejectedDeviceFieldValue('isOn')}
			mode={this.state.trialRejectedDevicesEditDialogMode}
			show={this.state.showTrialRejectedDevicesEditDialog}
			onClose={this.closeTrialRejectedDevicesEditDialog}
		/>
	);

	closeTrialRejectedDevicesEditDialog = () => {
		this.setState({ showTrialRejectedDevicesEditDialog: false });
	};

	createNewTrialRejectedDevice = () => {
		this.setState({
			showTrialRejectedDevicesEditDialog: true,
			trialRejectedDevicesEditDialogMode: TrialRejectedDevicesEditDialog.Mode.Create,
		});
	};

	updateTrialRejectedDevice = () => {
		this.setState({
			showTrialRejectedDevicesEditDialog: true,
			trialRejectedDevicesEditDialogMode: TrialRejectedDevicesEditDialog.Mode.Edit,
		});
	};

	isEditButtonDisabled = () => this.props.selectedTrialRejectedDevices.length !== 1;

	renderHistoryDialog = () => {
		return (
			<TrialRejectedDeviceHistoryDialog
				show={this.state.showHistoryDialog}
				onClose={this.closeHistoryDialog}
				id={this.getSelectedTrialRejectedDeviceFieldValue('id')}
			/>
		);
	};

	showTrialRejectedDeviceHistory = () => {
		this.setState({ showHistoryDialog: true });
	};

	closeHistoryDialog = () => {
		this.setState({ showHistoryDialog: false });
	};

	isHistoryButtonDisabled = () => this.props.selectedTrialRejectedDevices.length !== 1;

	getSelectedTrialRejectedDeviceFieldValue = (fieldName, defaultValue = null) => {
		const trialRejectedDevice = this.props.selectedTrialRejectedDevices[0];
		if (!trialRejectedDevice) return null;
		try {
			const value = fieldName.split('.').reduce((acc, key) => acc[key], trialRejectedDevice);
			return value === undefined ? defaultValue : value === null ? defaultValue : value;
		} catch (e) {
			return defaultValue;
		}
	};
}

const mapStateToProps = (state) => ({
	isTrialRejectedDevicesFetching: trialRejectedDevicesSelectors.isFetching(state),
	trialRejectedDevices: trialRejectedDevicesSelectors.selectAll(state),
	trialRejectedDevicesFetchingError: trialRejectedDevicesSelectors.fetchingError(state),

	selectedTrialRejectedDevicesIds: userConfigsSelectors.selectedItems(state, thatObjectName),
	selectedTrialRejectedDevices: trialRejectedDevicesSelectors.selectedTrialRejectedDevices(state),

	selectedOnceAYear: trialSettingsSelectors.selectOnceAYear(state),
	selectedMinAllowedViewerVersion: trialSettingsSelectors.selectMinAllowedViewerVersion(state),
});

const actionCreators = {
	fetchAllTrialRejectedDevices: trialRejectedDevicesActions.fetchAllTrialRejectedDevices,
	fetchTrialSettings: trialSettingsActions.getTrialSettings,
};

export default connect(mapStateToProps, actionCreators)(TrialRejectedDevicesContainer);



// WEBPACK FOOTER //
// ./src/containers/trialSettingsContainer.js